export default __webpack_public_path__ + "static/media/nolimit.6b3afecc.svg";